import { useEffect } from "react";
import { useFusionAuth } from "@fusionauth/react-sdk";
import { useNavigate } from "react-router-dom"; // If using React Router

export default function OAuthRedirect() {
    const { isLoggedIn } = useFusionAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            navigate("/manage-profile"); // Change to your desired route
        }
    }, [isLoggedIn, navigate]);

    return <div>Signing you in...</div>;
}
